import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { SignupMembershipType } from '../types';

export const removeSpaces = (value: string) => value.replace(/\s+/g, '');

export const removeEmptyStringOrNilProperties = <T extends object>(input: T) =>
  omitBy<T>(input, (value) => value === '' || isNil(value));

export const isEntitlementUser = (type: SignupMembershipType) => type === SignupMembershipType.ENTITLEMENT;

export const isGen2User = (type: SignupMembershipType) => type === SignupMembershipType.LEGACY;

export const isPayingUser = (type: SignupMembershipType) => type === SignupMembershipType.PAYING;

// The following list have no currency symbols so normal formatting will result into
// weird string: CHF5.99 CHF. These cases are handled differently.
export const CURRENCIES_WITH_NO_SYMBOLS = new Set(['CHF', 'SAR', 'AED']);

export const getMonetaryValue = (value: number, currency: string): string => {
  // Use the same options as toLocaleString for consistency
  const formattedPrice = value.toLocaleString(undefined, {
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    currency,
  });

  if (CURRENCIES_WITH_NO_SYMBOLS.has(currency)) {
    return formattedPrice;
  }

  return `${formattedPrice} ${currency}`;
};

export const getDate = (date?: string): Date => new Date(date ?? Date.now());
